import { render, staticRenderFns } from "./StaffListTable.vue?vue&type=template&id=020ff735&"
import script from "./StaffListTable.vue?vue&type=script&lang=js&"
export * from "./StaffListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports